export const CheckCircle = ({ circleFill, ...props }) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.32917 9.22914L1.85417 5.75414L0.670837 6.92914L5.32917 11.5875L15.3292 1.58748L14.1542 0.412476L5.32917 9.22914Z"
        fill="white"
      />
    </svg>
  );
};
export const RippleLoaderSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200px"
    height="200px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    fill="none"
  >
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-mainthemeBlack"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
    </circle>
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-mainthemeBlack"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
    </circle>
  </svg>
);
export const CartVector = (props) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V6C0 5.45 0.195833 4.97917 0.5875 4.5875C0.979167 4.19583 1.45 4 2 4H4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4H14C14.55 4 15.0208 4.19583 15.4125 4.5875C15.8042 4.97917 16 5.45 16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V6H12V8C12 8.28333 11.9042 8.52083 11.7125 8.7125C11.5208 8.90417 11.2833 9 11 9C10.7167 9 10.4792 8.90417 10.2875 8.7125C10.0958 8.52083 10 8.28333 10 8V6H6V8C6 8.28333 5.90417 8.52083 5.7125 8.7125C5.52083 8.90417 5.28333 9 5 9C4.71667 9 4.47917 8.90417 4.2875 8.7125C4.09583 8.52083 4 8.28333 4 8V6H2V18ZM6 4H10C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4Z"
        fill="#3E2B00"
      />
    </svg>
  );
};
export const CloseVector = ({ props, fillClass }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8334 1.34163L10.6584 0.166626L6.00008 4.82496L1.34175 0.166626L0.166748 1.34163L4.82508 5.99996L0.166748 10.6583L1.34175 11.8333L6.00008 7.17496L10.6584 11.8333L11.8334 10.6583L7.17508 5.99996L11.8334 1.34163Z"
        fill="#D32F2F"
        className={fillClass}
      />
      <path
        d="M11.8334 1.34163L10.6584 0.166626L6.00008 4.82496L1.34175 0.166626L0.166748 1.34163L4.82508 5.99996L0.166748 10.6583L1.34175 11.8333L6.00008 7.17496L10.6584 11.8333L11.8334 10.6583L7.17508 5.99996L11.8334 1.34163Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  );
};
export const UpArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.294983L0 6.29498L1.41 7.70498L6 3.12498L10.59 7.70498L12 6.29498L6 0.294983Z"
        fill="#8F6500"
      />
    </svg>
  );
};
export const ZoomOut = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 20L15.65 15.65M10 7V13M7 10H13M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
        stroke="black"
        stroke-opacity="0.6"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Decriment = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#8F6500" />
      <path
        d="M22.5 15C22.5 15.1658 22.4342 15.3247 22.3169 15.4419C22.1997 15.5592 22.0408 15.625 21.875 15.625H8.125C7.95924 15.625 7.80027 15.5592 7.68306 15.4419C7.56585 15.3247 7.5 15.1658 7.5 15C7.5 14.8342 7.56585 14.6753 7.68306 14.5581C7.80027 14.4408 7.95924 14.375 8.125 14.375H21.875C22.0408 14.375 22.1997 14.4408 22.3169 14.5581C22.4342 14.6753 22.5 14.8342 22.5 15Z"
        fill="#8F6500"
      />
    </svg>
  );
};
export const Increment = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#8F6500" />
      <path
        d="M22.5 15C22.5 15.1658 22.4342 15.3247 22.3169 15.4419C22.1997 15.5592 22.0408 15.625 21.875 15.625H15.625V21.875C15.625 22.0408 15.5592 22.1997 15.4419 22.3169C15.3247 22.4342 15.1658 22.5 15 22.5C14.8342 22.5 14.6753 22.4342 14.5581 22.3169C14.4408 22.1997 14.375 22.0408 14.375 21.875V15.625H8.125C7.95924 15.625 7.80027 15.5592 7.68306 15.4419C7.56585 15.3247 7.5 15.1658 7.5 15C7.5 14.8342 7.56585 14.6753 7.68306 14.5581C7.80027 14.4408 7.95924 14.375 8.125 14.375H14.375V8.125C14.375 7.95924 14.4408 7.80027 14.5581 7.68306C14.6753 7.56585 14.8342 7.5 15 7.5C15.1658 7.5 15.3247 7.56585 15.4419 7.68306C15.5592 7.80027 15.625 7.95924 15.625 8.125V14.375H21.875C22.0408 14.375 22.1997 14.4408 22.3169 14.5581C22.4342 14.6753 22.5 14.8342 22.5 15Z"
        fill="#8F6500"
      />
    </svg>
  );
};
export const SelectVector = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
        fill="#3E2B00"
      />
    </svg>
  );
};
export const Calender = ({ props, fillClass }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.875 1.75H13.8125V1.0625C13.8125 0.880164 13.7401 0.705295 13.6111 0.576364C13.4822 0.447433 13.3073 0.375 13.125 0.375C12.9427 0.375 12.7678 0.447433 12.6389 0.576364C12.5099 0.705295 12.4375 0.880164 12.4375 1.0625V1.75H5.5625V1.0625C5.5625 0.880164 5.49007 0.705295 5.36114 0.576364C5.2322 0.447433 5.05734 0.375 4.875 0.375C4.69266 0.375 4.5178 0.447433 4.38886 0.576364C4.25993 0.705295 4.1875 0.880164 4.1875 1.0625V1.75H2.125C1.76033 1.75 1.41059 1.89487 1.15273 2.15273C0.894866 2.41059 0.75 2.76033 0.75 3.125V16.875C0.75 17.2397 0.894866 17.5894 1.15273 17.8473C1.41059 18.1051 1.76033 18.25 2.125 18.25H15.875C16.2397 18.25 16.5894 18.1051 16.8473 17.8473C17.1051 17.5894 17.25 17.2397 17.25 16.875V3.125C17.25 2.76033 17.1051 2.41059 16.8473 2.15273C16.5894 1.89487 16.2397 1.75 15.875 1.75ZM4.1875 3.125V3.8125C4.1875 3.99484 4.25993 4.1697 4.38886 4.29864C4.5178 4.42757 4.69266 4.5 4.875 4.5C5.05734 4.5 5.2322 4.42757 5.36114 4.29864C5.49007 4.1697 5.5625 3.99484 5.5625 3.8125V3.125H12.4375V3.8125C12.4375 3.99484 12.5099 4.1697 12.6389 4.29864C12.7678 4.42757 12.9427 4.5 13.125 4.5C13.3073 4.5 13.4822 4.42757 13.6111 4.29864C13.7401 4.1697 13.8125 3.99484 13.8125 3.8125V3.125H15.875V5.875H2.125V3.125H4.1875ZM15.875 16.875H2.125V7.25H15.875V16.875Z"
        fill="black"
        fill-opacity="0.6"
        className={fillClass}
      />
    </svg>
  );
};
export const DateCalender = ({ props, fillClass }) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z"
        fill="#3E2B00"
      />
    </svg>
  );
};
export const Handshake = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2919 14.7292C10.2547 14.878 10.1689 15.01 10.0481 15.1044C9.92723 15.1987 9.77832 15.25 9.62501 15.25C9.56709 15.2503 9.50935 15.2434 9.45314 15.2294L6.70314 14.5419C6.62658 14.5227 6.5539 14.4904 6.48829 14.4465L4.42579 13.0715C4.27411 12.9703 4.16884 12.813 4.13315 12.6342C4.09745 12.4554 4.13425 12.2697 4.23544 12.118C4.33664 11.9663 4.49395 11.8611 4.67276 11.8254C4.85157 11.7897 5.03724 11.8265 5.18892 11.9277L7.15173 13.2365L9.78658 13.8956C9.87461 13.917 9.95756 13.9555 10.0307 14.009C10.1037 14.0625 10.1656 14.1299 10.2125 14.2074C10.2595 14.2849 10.2907 14.3708 10.3043 14.4604C10.3179 14.5499 10.3137 14.6413 10.2919 14.7292ZM21.6949 6.43969C21.6385 6.61103 21.5487 6.7695 21.4307 6.90594C21.3127 7.04238 21.1689 7.15409 21.0074 7.23461L18.9724 8.25211L14.239 12.9864C14.155 13.0703 14.0507 13.1311 13.9362 13.1627C13.8218 13.1943 13.7011 13.1958 13.5859 13.1669L8.08587 11.7919C8.00223 11.7709 7.92325 11.7344 7.85298 11.6845L3.08173 8.27789L0.995168 7.23461C0.669066 7.0716 0.421055 6.78574 0.305669 6.4399C0.190282 6.09407 0.216967 5.71656 0.379856 5.39039L2.5154 1.12016C2.67842 0.794058 2.96428 0.546046 3.31011 0.43066C3.65595 0.315274 4.03345 0.341958 4.35962 0.504847L6.2554 1.45016L10.8101 0.149066C10.9337 0.113723 11.0647 0.113723 11.1882 0.149066L15.7429 1.45016L17.6387 0.504847C17.9649 0.341958 18.3424 0.315274 18.6882 0.43066C19.034 0.546046 19.3199 0.794058 19.4829 1.12016L21.6185 5.39039C21.6999 5.55156 21.7486 5.72728 21.7617 5.90739C21.7749 6.08749 21.7522 6.26841 21.6949 6.43969ZM17.7263 7.55172L15.388 2.875H12.6535L8.93751 6.48438C10.0255 7.17961 11.7313 7.37125 13.2619 5.82868C13.3814 5.70819 13.5413 5.63618 13.7107 5.6265C13.8802 5.61682 14.0472 5.67016 14.1797 5.77625L17.1368 8.14555L17.7263 7.55172ZM1.60962 6.00485L3.12986 6.76539L5.2654 2.49516L3.74517 1.73461L1.60962 6.00485ZM16.1563 9.11922L13.7749 7.21227C12.0957 8.58727 9.96361 8.7686 8.19673 7.64196C8.02293 7.5314 7.87619 7.38321 7.76735 7.20832C7.6585 7.03344 7.59035 6.83634 7.56791 6.63158C7.54547 6.42682 7.56932 6.21963 7.6377 6.02533C7.70608 5.83102 7.81725 5.65456 7.96298 5.50899C7.96505 5.50648 7.96735 5.50418 7.96986 5.50211L11.825 1.76297L11 1.5275L6.66704 2.76586L4.31493 7.46922L8.54306 10.4899L13.5395 11.7386L16.1563 9.11922ZM20.3878 6.00485L18.2549 1.73461L16.7346 2.49516L18.8702 6.76539L20.3878 6.00485Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  );
};
export const Close = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6739 12.7011C13.7378 12.765 13.7885 12.8408 13.823 12.9243C13.8576 13.0077 13.8754 13.0972 13.8754 13.1875C13.8754 13.2778 13.8576 13.3673 13.823 13.4508C13.7885 13.5342 13.7378 13.61 13.6739 13.6739C13.61 13.7378 13.5342 13.7885 13.4508 13.823C13.3673 13.8576 13.2778 13.8754 13.1875 13.8754C13.0972 13.8754 13.0077 13.8576 12.9243 13.823C12.8408 13.7885 12.765 13.7378 12.7011 13.6739L7.00002 7.97197L1.29892 13.6739C1.16992 13.8029 0.994954 13.8754 0.812516 13.8754C0.630078 13.8754 0.455113 13.8029 0.32611 13.6739C0.197107 13.5449 0.124634 13.37 0.124634 13.1875C0.124634 13.0051 0.197107 12.8301 0.32611 12.7011L6.02806 7.00002L0.32611 1.29892C0.197107 1.16992 0.124634 0.994954 0.124634 0.812516C0.124634 0.630078 0.197107 0.455113 0.32611 0.32611C0.455113 0.197107 0.630078 0.124634 0.812516 0.124634C0.994954 0.124634 1.16992 0.197107 1.29892 0.32611L7.00002 6.02806L12.7011 0.32611C12.8301 0.197107 13.0051 0.124634 13.1875 0.124634C13.37 0.124634 13.5449 0.197107 13.6739 0.32611C13.8029 0.455113 13.8754 0.630078 13.8754 0.812516C13.8754 0.994954 13.8029 1.16992 13.6739 1.29892L7.97197 7.00002L13.6739 12.7011Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  );
};
export const ArrowNext = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0L7.09 1.41L12.67 7H0.5V9H12.67L7.09 14.59L8.5 16L16.5 8L8.5 0Z"
        fill="white"
      />
    </svg>
  );
};
export const ArrowBack = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="black"
        fill-opacity="0.87"
      />
    </svg>
  );
};
export const ContactVector = (props) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.84 3.22C17.79 3.1 17.73 2.99 17.66 2.88C17.52 2.67 17.33 2.48 17.12 2.34C17.01 2.27 16.9 2.21 16.78 2.16C16.54 2.06 16.28 2 16 2H15V0H13V2H5V0H3V2H2C1.58 2 1.2 2.13 0.88 2.34C0.67 2.48 0.48 2.67 0.34 2.88C0.27 2.99 0.21 3.1 0.16 3.22C0.0600001 3.46 0 3.72 0 4V18C0 19.1 0.89 20 2 20H16C16.28 20 16.54 19.94 16.78 19.84C16.9 19.79 17.01 19.73 17.12 19.66C17.33 19.52 17.52 19.33 17.66 19.12C17.87 18.8 18 18.41 18 18V4C18 3.72 17.94 3.46 17.84 3.22ZM2 18V4H16V18H2ZM9 11.88C6.97 11.88 3 12.96 3 15.46V17H15V15.47C15 12.96 11.03 11.88 9 11.88ZM5.31 15C6 14.44 7.69 13.88 9 13.88C10.31 13.88 12.01 14.44 12.69 15H5.31ZM9 11C10.65 11 12 9.65 12 8C12 6.35 10.65 5 9 5C7.35 5 6 6.35 6 8C6 9.65 7.35 11 9 11ZM9 7C9.55 7 10 7.45 10 8C10 8.55 9.55 9 9 9C8.45 9 8 8.55 8 8C8 7.45 8.45 7 9 7Z"
        fill="#3E2B00"
      />
    </svg>
  );
};
export const DownFillArrow = (props) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0.5L5 5.5L10 0.5H0Z" fill="black" fill-opacity="0.54" />
    </svg>
  );
};
export const FillColse = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 0.25C9.74875 0.25 0.25 9.74875 0.25 21.5C0.25 33.2513 9.74875 42.75 21.5 42.75C33.2513 42.75 42.75 33.2513 42.75 21.5C42.75 9.74875 33.2513 0.25 21.5 0.25ZM32.125 29.1287L29.1287 32.125L21.5 24.4963L13.8713 32.125L10.875 29.1287L18.5037 21.5L10.875 13.8713L13.8713 10.875L21.5 18.5037L29.1287 10.875L32.125 13.8713L24.4963 21.5L32.125 29.1287Z"
        fill="#D1D1D1"
      />
    </svg>
  );
};
export const AddCart = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12.5C4.175 12.5 3.5075 13.175 3.5075 14C3.5075 14.825 4.175 15.5 5 15.5C5.825 15.5 6.5 14.825 6.5 14C6.5 13.175 5.825 12.5 5 12.5ZM0.5 0.5V2H2L4.7 7.6925L3.6875 9.53C3.5675 9.74 3.5 9.9875 3.5 10.25C3.5 11.075 4.175 11.75 5 11.75H14V10.25H5.315C5.21 10.25 5.1275 10.1675 5.1275 10.0625L5.15 9.9725L5.825 8.75H11.4125C11.975 8.75 12.47 8.4425 12.725 7.9775L15.41 3.11C15.47 3.005 15.5 2.8775 15.5 2.75C15.5 2.3375 15.1625 2 14.75 2H3.6575L2.9525 0.5H0.5ZM12.5 12.5C11.675 12.5 11.0075 13.175 11.0075 14C11.0075 14.825 11.675 15.5 12.5 15.5C13.325 15.5 14 14.825 14 14C14 13.175 13.325 12.5 12.5 12.5Z"
        fill="#8F6500"
      />
    </svg>
  );
};
export const LoaderSvg = ({ pathClass, ...props }) => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      class="inline w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
        className={pathClass}
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
        className={pathClass}
      ></path>
    </svg>
  );
};
